import axios from 'axios';
import Vue from 'vue';
import VueLocalStorage from 'vue-localstorage';
const querystring=require('querystring');
Vue.use(VueLocalStorage);
let instance = null;
var BASE_URL = process.env.VUE_APP_BASEURL;

const HTTP = axios.create({
  baseURL: BASE_URL,
  crossDomain: true,
  headers: {
    'X-ACCESS-TOKEN': `Token ${Vue.localStorage.get('accessToken')}`
  }
})

class Service {
  constructor() {
    if (!instance) {
      instance = this;
    }
    return instance;
  }
  /**
   * PARA SETEAR TOKEN 
   */
  updateHeaders({ accessToken, userId,user}) {
    Vue.localStorage.set('userId', userId);
    Vue.localStorage.set('accessToken', accessToken);
    Vue.localStorage.set('businessId', user.cachedBusinessId);
    axios.defaults.headers.common['X-ACCESS-TOKEN'] = accessToken;
  }
  /**
   * LOGIN
   */
  login(creds) {
    return HTTP.post(`/users/login/`, creds);
  }
  /**
   * CURRENT USER
   */
  getCurrentUser() {
      return HTTP.get(`/users/${Vue.localStorage.get('userId')}`);
  }
  findUser(payload){
    return HTTP.get(`/users/find?field=${payload.field}`);
  }
  findTeam(payload){
    return HTTP.get(`/teams/find?field=${payload.field}`);
  }
  
  cachedBusiness(payload){
    Vue.localStorage.set('businessId', payload.id);
    return HTTP.post(`/users/${Vue.localStorage.get('userId')}/cachebusiness`,payload);
  }
  getNotifications(payload={}){
    let qs=querystring.stringify(payload)
    return HTTP.get(`/users/${Vue.localStorage.get('userId')}/notifications?${qs}`);
  }
  /**
   * Areas
   */
  areas({ businessId,branchoffice }) {
    return HTTP.get(`/business/${businessId}/areas?branchoffice=${branchoffice}`)
  }
  myAreas({autorId}){
    return HTTP.get(`/users/${autorId}/areas`)
  }



  dataGroups({ businessId ,branchoffice }) {
    return HTTP.get(`/business/${businessId}/datagroups?branchoffice=${branchoffice}`)
  }
  myDataGroups({autorId}){
    return HTTP.get(`/users/${autorId}/datagroups`)
  }
  addNewDatagroup(payload) {
    return HTTP.post(`/datagroups`,payload);
  }

  //Packs collecciones

  addPack(payload){
    return HTTP.post(`/datagroups/${payload.datagroupId}/packs`,payload)
  }
  getPacks(payload){
    return HTTP.get(`/business/${payload.businessId}/packs`)
  }

  genPackSource(payload){
    return HTTP.put(`/pack/${payload.id}/linksources`,payload);
  }
  getPackdata(payload){
    return HTTP.get(`/pack/${payload.id}/cards`);
  }

  getDecoyCards(payload){
    return HTTP.get(`/pipelines/${payload.id}/decoycards`);
  }

  createPackcard(payload){
    return HTTP.post(`/pack/${payload.id}/cards`,payload);
  }

  // updatePackcard(payload){
  //   return HTTP.put(`/pack/${payload.id}/cards`,payload);
  // }

  getallBoards({ businessId }) {
    return HTTP.get(`/business/${businessId}/boards`)
  }
  getallPipelines({ businessId }) {
    return HTTP.get(`/business/${businessId}/pipelines`)
  }
  areaDetail({id}) {
    return HTTP.get(`/areas/${id}`)
  }
  addNewArea(payload) {
    return HTTP.post(`/areas`,payload);
  }
  addBoard(payload){
    return HTTP.post(`/areas/${payload.areaId}/boards`,payload)
  }

  /**
   * MEMBERS
   */
  getBusinessMembers({ businessId }) {
    return HTTP.get(`/business/${businessId}/users`)
  }
  addBusinessMember(payload){
    return HTTP.put(`/business/${payload.businessId}/users`,payload)
  }

  /**
   * SCHEMES BUSINESS
   */
  
  getSchemaList(payload){
    return HTTP.get(`/business/${payload.businessId}/schemes`)
  }
  /**
   * BOARDS
   */
  board({ id }) {
    return HTTP.get(`/boards/${id}`)
  }
  updateBoard(payload){
    return HTTP.put(`/boards/${payload.id}`,payload)
  }
  addBoardPipeline(payload){
    return HTTP.post(`/boards/${payload.boardId}/pipeline`,payload)
  }
  addTeamOrMember(payload){
    return HTTP.post(`/boards/${payload.id}/addmembers`,payload)
  }
  removeTeamOrMember(payload){
    return HTTP.post(`/boards/${payload.id}/removemembers`,payload)
  }
  addBoardTarget(payload){
    return HTTP.post(`/boards/${payload.id}/targets`,payload)
  }  
  getTargets(payload){
    return HTTP.get(`/boards/${payload.id}/targets`)
  }

  /**
   * TARGET 
   */
  updateTarget(payload){
    return HTTP.put(`/targets/${payload.id}`,payload)
  }

  /**
   * CARDS
   */
  cards({ business }) {
    return HTTP.get(`/boards/${areaId}/cards`)
  }
  addCard(payload){
    return HTTP.post(`/boards/${payload.boardId}/cards`,payload)
  }  
  updateBoardColortags(payload){
    return HTTP.post(`/boards/${payload.id}/colortags`,payload)
  }
  getColortags(payload){
    return HTTP.get(`/boards/${payload.id}/colortags`)
  }
  getCardFrecuencies(payload){
    return HTTP.get(`/cards/${payload.id}/cronjobs?pipeline=${payload.pipeline}`)
  }

  //Frecuencia pipeline:
  createFrecuency(payload){
    return HTTP.post(`/pipelines/${payload.pipeline}/cronjobs`,payload);
  }
  updateFrecuency(payload){
    return HTTP.put(`/cronjobs/${payload.id}`,payload);
  }
  deleteFrecuency(payload){
    return HTTP.delete(`/cronjobs/${payload.id}?card=${payload.card}`)
  }
  
  /**
   * CARDS
   */
  updateCard(payload){
    return HTTP.put(`/cards/${payload.id}`,payload)
  }

  /**
   * PROXY-CARDS
   */
  updateProxyCard(payload){
    return HTTP.put(`/proxycards/${payload.id}`,payload)
  }
  proxyCardAddComment(payload){
    return HTTP.post(`/proxycards/${payload.proxycardId}/comments`,payload)
  }
  proxyCardDetail(payload){
    return HTTP.get(`/proxycards/${payload.id}/`)
  }
  addCheckBox(payload){
    return HTTP.post(`/proxycards/${payload.proxycardId}/checkboxes`,payload)
  }
  addProxyCardMembers(payload){
    return HTTP.put(`/proxycards/${payload.id}/members`,payload)  
  }
  deleteProxyCardMember(payload){
    return HTTP.delete(`/proxycards/${payload.id}/members/${payload.member}`)  
  }

  attachProxycardIntegrationData(payload){
    return HTTP.put(`/proxycards/${payload.id}/integrationdata`,payload)
  }
  addProxyCardAttachment(payload){
    return HTTP.put(`/proxycards/${payload.id}/attachments`,payload)
  }

  removeProxyCardAttachment(payload){
    return HTTP.put(`/proxycards/${payload.id}/removeattachments`,payload)
  }
  /**
   * CHECKBOXES
   */
  updateCheckBox(payload){
    return HTTP.put(`/checkboxes/${payload.id}`,payload)
  }
  deleteCheckBox(payload){
    return HTTP.delete(`/checkboxes/${payload.id}`)
  }
  /**
   * FILE UPLOAD
   */
  uploadFile(file){
    var formData=new FormData();
    formData.append('file_upload',file)
    return HTTP.post(`/attachments/upload`,formData);
  }

  /**
   * PIPELINES
   */
  getFullPipeline(payload){
    return HTTP.get(`/pipelines/${payload.id}/full`,payload)
  }
  updatePipeline(payload){
    return HTTP.put(`/pipelines/${payload.id}`,payload)
  }
   addpipHook({pipeline,hook}){
    return HTTP.post(`/pipelines/${pipeline}/hooks`,hook)
  }
  genShareLink(payload){
    return HTTP.put(`/pipelines/${payload.id}/gensharelink`)
  }

  // attachPackpipeline(payload){
  //   return HTTP.put(`/pipelines/${payload.id}/linkpacks`,payload)
  // }
  updatepipHook(payload){
    return HTTP.put(`/hooks/${payload.id}/`,payload)
  }
  addpipAction({pipeline,hook}){
    return HTTP.post(`/pipelines/${pipeline}/actions`,hook)
  }
  updatepipAction(payload){
    return HTTP.put(`/actions/${payload.id}/`,payload)
  }

  addpipTarget({pipeline,target}){
    return HTTP.post(`/pipelines/${pipeline}/conftargets`,target)
  }
  updatepipTarget(payload){
    return HTTP.put(`/conftargets/${payload.id}/`,payload)
  }

  deletepipHook(payload){
    return HTTP.delete(`/hooks/${payload.id}/`)
  }

  getSchema(payload){
    return HTTP.get(`/pack/${payload.id}/scheme`)
  }
  setSchema(payload){
    return HTTP.put(`/pack/${payload.id}/scheme`,payload)
  }
  /**
   * 
   * SHARELINK
   */

  getSharelinkDetail({uuid}){
    return HTTP.get(`/sharelinks/findOne?uuid=${uuid}`)
  }

  /**
   * TEAMS
   */
  createTeam(payload){
    return HTTP.post(`/teams/`,payload)
  }
  getMyTeams(payload){
    return HTTP.get(`/users/${payload.userId}/teams`)
  }
  getBusinessTeams(payload){
    return HTTP.get(`/business/${payload.businessId}/teams`)
  }
  getTeamDetail(payload){
    return HTTP.get(`/teams/${payload.id}/`)
  }
  addTeamMembers(payload){
    return HTTP.put(`/teams/${payload.id}/addmembers`,payload)
  }
  /**
   * BRANCHS
   */
  getBusinessBranchs(payload){
    return HTTP.get(`/business/${payload.businessId}/branchs`)
  }
  createBranch(payload){
    return HTTP.post(`/branchs/`,payload)
  }

  /**
   * 
   * INTEGRACIONES
   */
  integraionshub(){
    return HTTP.get(`/integrationshub`);
  }
  integraions({businessId}){
    return HTTP.get(`/business/${businessId}/integrations`);
  }
  createIntegration(payload){
    return HTTP.post(`/integrations`,payload);
  }


  myIntegraions({ownerId}){
    return HTTP.get(`/users/${ownerId}/integrations`)
  }
  /**
   * LINK BOARD INTEGRATION
   */
  linkBoardIntegration(payload){
    return HTTP.put(`/boards/${payload.board}/integrations`,payload)
  }


  //HUNTBAN SCRIPTS
  getPiplockinfo(payload){
    return HTTP.get(`/hscripts/info`,{params:payload})
  }

  // 
  myTodayCards(){

  }
  //TODAY APIS
  getTodayCards(payload){
    return HTTP.get(`/business/${payload.businessId}/today`,{
      params:{
        day:new Date()
      }
    })
  }

  
}

export const service = new Service()
